import processHtmlAttributes from "../../common/html-attributes"

static function noop() {}

static var ignoredAttributes = ["class", "open", "type", "size", "text", "toJSON"];

$ input.toJSON = noop;
<details
    ...processHtmlAttributes(input, ignoredAttributes)
    class=["details", input.class]
    open=input.open
    key="root"
    on-toggle("toggleDetails")
    on-click("clickDetails")>
    <summary class=[
        "details__summary",
        input.size === "small" && "details__summary--small",
        input.type === "center" && "details__summary--center"
    ]>
        <span class="details__label">${input.text}</span>
        <span class="details__icon" hidden>
            <ebay-dropdown-icon/>
        </span>
    </summary>
    <${input.as || "p"}>
        <${input.renderBody}/>
    </>
</details>
